import * as types from './LiveAvailableShiftsActionType';


export const fetchLiveAvailableShiftsRequest = (payload) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST,
    payload,
});
export const fetchLiveAvailableShiftsSuccess = (payload) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_SUCCESS,
    payload,
});
export const fetchLiveAvailableShiftsFailure = (error) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_FAILURE,
    error,
});

export const fetchModalScheduleRequest = (payload) => ({
    type: types.FETCH_MODAL_SCHEDULE_REQUEST,
    payload,
});
export const fetchModalScheduleSuccess = (payload) => ({
    type: types.FETCH_MODAL_SCHEDULE_SUCCESS,
    payload,
});
export const fetchModalScheduleFailure = (error) => ({
    type: types.FETCH_MODAL_SCHEDULE_FAILURE,
    error,
});

export const fetchLegendTableDataRequest = (payload) => ({
    type: types.FETCH_LEGEND_TABLE_DATA_REQUEST,
    payload,
});
export const fetchLegendTableDataSuccess = (payload) => ({
    type: types.FETCH_LEGEND_TABLE_DATA_SUCCESS,
    payload,
});
export const fetchLegendTableDataFailure = (error) => ({
    type: types.FETCH_LEGEND_TABLE_DATA_FAILURE,
    error,
});

export const fetchPriorityGroupingLegendRequest = () => ({
    type: types.FETCH_PRIORITY_GROUPING_LEGEND_REQUEST,
});
export const fetchPriorityGroupingLegendSuccess = (payload) => ({
    type: types.FETCH_PRIORITY_GROUPING_LEGEND_SUCCESS,
    payload,
});
export const fetchPriorityGroupingLegendFailure = (error) => ({
    type: types.FETCH_PRIORITY_GROUPING_LEGEND_FAILURE,
    error,
});

export const fetchRadRequestTypeRequest = () => ({
    type: types.FETCH_RAD_REQUEST_TYPE_REQUEST,
});
export const fetchRadRequestTypeSuccess = (payload) => ({
    type: types.FETCH_RAD_REQUEST_TYPE_SUCCESS,
    payload,
});
export const fetchRadRequestTypeFailure = (error) => ({
    type: types.FETCH_RAD_REQUEST_TYPE_FAILURE,
    error,
});

export const saveRadRequestRequest = (data, onSuccess = null) => ({
    type: types.SAVE_RAD_REQUEST_REQUEST,
    payload: { data, onSuccess },
});
export const saveRadRequestSuccess = (payload) => ({
    type: types.SAVE_RAD_REQUEST_SUCCESS,
    payload,
});
export const saveRadRequestFailure = (error) => ({
    type: types.SAVE_RAD_REQUEST_FAILURE,
    error,
});

export const fetchScheduleRecurrenceRequest = () => ({
    type: types.FETCH_SCHEDULE_RECURRENCE_REQUEST,
});
export const fetchScheduleRecurrenceSuccess = (payload) => ({
    type: types.FETCH_SCHEDULE_RECURRENCE_SUCCESS,
    payload,
});
export const fetchScheduleRecurrenceFailure = (error) => ({
    type: types.FETCH_SCHEDULE_RECURRENCE_FAILURE,
    error,
});
export const fetchLiveAvailableShiftsFiltersRequest = (reportId) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST,
    payload: reportId,
});
export const fetchLiveAvailableShiftsFiltersSuccess = (payload) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_SUCCESS,
    payload,
});
export const fetchLiveAvailableShiftsFiltersFailure = (error) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_FAILURE,
    error,
});
export const fetchLiveAvailableShiftsWorklistRequest = (groupId) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_REQUEST,
    payload: groupId,
});
export const fetchLiveAvailableShiftsWorklistSuccess = (payload) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_SUCCESS,
    payload,
});
export const fetchLiveAvailableShiftsWorklistFailure = (error) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_FAILURE,
    error,
});


export const saveLiveAvailableShiftsFiltersRequest = (data, onSuccess = null) => ({
    type: types.SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST,
    payload: { data, onSuccess },
});
export const saveLiveAvailableShiftsFiltersSuccess = (payload) => ({
    type: types.SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_SUCCESS,
    payload,
});
export const saveLiveAvailableShiftsFiltersFailure = (error) => ({
    type: types.SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_FAILURE,
    error,
});